import * as React from "react";

function SvgHydra(props, ref) {
  return (
    <svg
      id="Hydra_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 569.2 711.5"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Hydra_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}"}
      </style>
      <path
        d="M569.2 28.5c0-7.6-3-14.8-8.3-20.1C555.5 3 548.3 0 540.7 0H28.5C20.9 0 13.7 3 8.3 8.3 3 13.7 0 20.9 0 28.5V683c0 7.6 3 14.8 8.3 20.1 5.3 5.3 12.6 8.3 20.1 8.3h512.3c7.6 0 14.8-3 20.1-8.3 5.3-5.3 8.3-12.6 8.3-20.1.1-114.4.1-540.1.1-654.5z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4b6cd6"
      />
      <path
        className="Hydra_svg__st2"
        d="M256.9 300c.8 5.8 2.9 10.4 6 13.2l63.2 61.4.6.6.2.2c8 8.5 12.6 20.6 12.6 33.4v134.7l-27.2 21.1V413 410.6c-.1-7.4-1.9-13.7-4.4-15.6l-63.8-62c-8.8-7.6-14.4-19.6-14.4-32.9V168.9l27.2-22V300z"
      />
      <path
        className="Hydra_svg__st2"
        d="M231 357.6v96.6h24.5v-96.6c-.1-6.8-5.5-12.2-12.2-12.2s-12.2 5.5-12.3 12.2z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgHydra);
